import { render, staticRenderFns } from "./AdvancedDetail.vue?vue&type=template&id=03facd50&scoped=true"
import script from "./AdvancedDetail.vue?vue&type=script&lang=js"
export * from "./AdvancedDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03facd50",
  null
  
)

export default component.exports